import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FolderForwardIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path d="M7 17.6H5.4L2 21V5.7C2 4.765 2.765 4 3.7 4h13.6c.935 0 1.7.765 1.7 1.7v2.95h-1.7V5.7H3.7v10.2H7v1.7ZM17.2925 13.4824l.0129-3.0049 5.6743 5.283-5.7194 5.2342.0132-3.08c-4.0691-.0175-6.9227 1.1723-8.96852 3.7929.82993-3.7527 3.28752-7.4983 8.98752-8.2252Z" />
  </Icon>
);

export default memo(FolderForwardIcon);
